import { render, staticRenderFns } from "./EditEntregaModal.vue?vue&type=template&id=79e0d82f&scoped=true"
import script from "./EditEntregaModal.vue?vue&type=script&lang=js"
export * from "./EditEntregaModal.vue?vue&type=script&lang=js"
import style0 from "./EditEntregaModal.vue?vue&type=style&index=0&id=79e0d82f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e0d82f",
  null
  
)

export default component.exports